import { useQuery } from 'hooks/useCustomQuery';
import getAllTrunks from '@/API/Trunk/getAllTrunks';
import TrunkType from '@/utils/enums/TrunkType';

const useGetTeamsTrunks = (
    companyId,
    accountScope,
    setTrunks,
    platformId,
    setCallingProfiles,
    isOpen,
    platformList,
) => {
    const isPlatformIdPresent = platformList?.some(
        (platform) => platform.id === platformId,
    );
    return useQuery({
        queryKey: ['trunks', companyId, platformId, accountScope],
        queryFn: async () => {
            const data = await getAllTrunks(
                companyId,
                accountScope,
                platformId,
            ).then((res) => {
                setTrunks(res);

                const isOC = res?.filter(
                    (trunk) => trunk.trunkTypeID === TrunkType.OPERATOR_CONNECT,
                );
                const callingProfileList = isOC?.flatMap((trunk) => {
                    return trunk?.callingProfileList || [];
                });

                setCallingProfiles(callingProfileList);
                return res;
            });
            return data;
        },
        refetchOnWindowFocus: false,
        enabled: isOpen && !!platformId && isPlatformIdPresent,
        staleTime: 0,
    });
};

export default useGetTeamsTrunks;
